import React from 'react';
import styles from './css/index.module.css';

const AiWardenThemesPanel = ({ onSubmit, submitting }) => {
    return (
        <>
            <p className={styles.aiWardenTip}>
                Explore major themes, entities, recurring patterns, and emerging concerns in the selected scope using retrieved evidence only.
            </p>
            <div className={styles.aiWardenAskActions}>
                <button type="button" className={styles.aiWardenPrimaryBtn} onClick={onSubmit} disabled={submitting}>
                    {submitting ? 'Thinking…' : 'Explore Themes'}
                </button>
                <span className={styles.aiWardenTip}>Output uses only retrieved context from your selection.</span>
            </div>
        </>
    );
};

export default AiWardenThemesPanel;
